import BaseApi from "./BaseApi";

export default class DadosCadastraisService {

    static putContato(command) {
        return BaseApi.put(`/dadosCadastrais/v1/atualizaDados`, command);
    }

    static putEndereco(command) {
        return BaseApi.put(`/dadosCadastrais/v1/atualizaEndereco`, command);
    }

    static putSenha(command) {
        return BaseApi.put(`/dadosCadastrais/v1/atualizaSenha`, command);
    }

    static get(ru) {
        return BaseApi.get(`/dadosCadastrais/v1/${ru}`);
    }

    static getTipoEndereco() {
        return BaseApi.get(`/dadosCadastrais/v1/tipoEndereco`);
    }

    static getEnderecoByCep(cep) {
        return BaseApi.get(`/dadosCadastrais/v1/endereco/${cep}`);
    }
}